const Loading = () => {
  return (
    <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
      <div className="flex flex-col">
        <div className="flex flex-row space-x-8">
          <div className="w-16 h-16 rounded-full animate-spin border-y-4 border-solid border-blue-500 border-t-transparent">
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
